import React from 'react';
import { TopnavDropdownMenu } from 'common/topnav-dropdown-menu';
import { isAnyLoggedUser } from 'helpers/utils';

type RightSectionProps = {
  user: UserType;
  logOutUser: () => void;
};

// The same account menu as the vault top bar; visitors without an account get
// none.
const RightSection: React.FC<RightSectionProps> = ({ user, logOutUser }) =>
  isAnyLoggedUser(user) ? <TopnavDropdownMenu onLogout={logOutUser} /> : null;

export { RightSection };
